'use strict';

exports.__esModule = true;
exports.results = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _resultsActions = require('../actions/results-actions');

var _advancedSearchBarActions = require('../actions/advanced-search-bar-actions');

var _reactRouterRedux = require('react-router-redux');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _searchResults = require('../transformers/search-results');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
	loadingResults: true
};

var updateMarkers = function updateMarkers(state, marker, showInfo) {
	return state.markers.map(function (item) {
		return item === marker && (0, _extends3.default)({}, item, { showInfo: showInfo }) || item.showInfo === true && (0, _extends3.default)({}, item, { showInfo: false }) || item;
	});
};

var updateResultsAvailabilities = function updateResultsAvailabilities(results, id, availabilities, startDate) {
	return results.map(function (result) {
		if (result.id === id) {
			return (0, _extends3.default)({}, result, {
				availabilities: (0, _searchResults.transformAvailabilities)(availabilities, startDate),
				nextAvailableAt: (0, _searchResults.nextAvailable)(availabilities, startDate)
			});
		} else {
			return result;
		}
	});
};

var results = exports.results = function results(state, action) {
	switch (action.type) {
		case _reactRouterRedux.LOCATION_CHANGE:
			return (0, _extends3.default)({}, state);
		case _resultsActions.UPDATE_RESULTS + '_REQUESTED':
			return (0, _assign2.default)({}, state, { loadingResults: true });
		case _resultsActions.UPDATE_RESULTS + '_FAILED':
			return (0, _assign2.default)({}, state, { loadingResults: false });
		case _resultsActions.UPDATE_RESULTS + '_RECEIVED':
			return (0, _assign2.default)({}, state, {
				searchOnLoad: false,
				loadingResults: false,
				totalResults: action.response.record_count,
				searchResults: (0, _searchResults.transformResults)(action.response.search_results, action.actionData.listings.specialties, action.response.dates && action.response.dates.startdate || new _moment2.default.utc().format('DD-MM-YYYY'), action.actionData.searchType, action.actionData.searchedNetwork),
				startDate: action.response.dates && action.response.dates.startdate || new _moment2.default.utc().format('DD-MM-YYYY'),
				markers: (0, _searchResults.transformMarkers)(action.response.search_results)
			});
		case _advancedSearchBarActions.UPDATE_SELECTED_KEYWORD:
			return (0, _assign2.default)({}, state, { bookingType: action.keyword });
		case _resultsActions.ON_MARKER_CLICKED:
			return (0, _assign2.default)({}, state, { markers: updateMarkers(state, action.marker, !action.marker.showInfo) });
		case _resultsActions.UPDATE_MARKERS:
			return (0, _assign2.default)({}, state, { markers: action.markers });
		case _resultsActions.ON_MARKER_CLOSED:
			return (0, _assign2.default)({}, state, { markers: updateMarkers(state, action.marker, false) });
		case _resultsActions.RESULT_HOVER:
			return (0, _assign2.default)({}, state, { markers: updateMarkers(state, state.markers[state.markers.findIndex(function (marker) {
					return marker.practice_id === action.id;
				})], true) });
		case _resultsActions.UPDATE_SELECTED_PAGE:
			return (0, _assign2.default)({}, state, { selectedPage: action.page });
		case _resultsActions.UPDATE_AVAILABILITY + '_RECEIVED':
			return (0, _assign2.default)({}, state, {
				searchResults: updateResultsAvailabilities(state.searchResults, action.actionData && action.actionData.id, action.response, action.actionData.startDate || new _moment2.default.utc())
			});
		default:
			return state || INITIAL_STATE;
	}
};


// WEBPACK FOOTER //
// ./components/search-page/lib/reducers/results-reducers.js